"use strict";

exports.__esModule = true;
exports.default = void 0;
var _restArguments = _interopRequireDefault(require("./restArguments.js"));
var _uniq = _interopRequireDefault(require("./uniq.js"));
var _flatten = _interopRequireDefault(require("./_flatten.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Produce an array that contains the union: each distinct element from all of
// the passed-in arrays.
var _default = exports.default = (0, _restArguments.default)(function (arrays) {
  return (0, _uniq.default)((0, _flatten.default)(arrays, true, true));
});